import React from 'react';

import { isPhoneValidHr } from './phoneUtilsHr';
import { formatPhoneHr } from './phoneUtilsHr';
import { TextField } from '../TextField';

const PhoneTextField = ({
  value,
  onChange,
  error,
  placeholder="npr. 01 478 1234",
  ...props
}: any) => {
  const phone = typeof value === 'string' ? value : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneHr(e.target.value);

    onChange?.({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: formatted,
      },
    });
  };

  const isValid = !phone || isPhoneValidHr(phone);

  // If phone is valid, don't show external error (it will clear on next form validation)
  const displayError = (phone && isValid) ? undefined : (!isValid ? 'Neispravan fiksni telefon' : error);

  return (
    <TextField
      {...props}
      value={phone}
      onChange={handleChange}
      error={displayError}
      placeholder={placeholder}
      inputMode="tel"
      disableDebounce
    />
  );
};

export default React.memo(PhoneTextField);
